const meta = {
  scripts: [{ src: 'https://boards.greenhouse.io/embed/job_board/js?for=fabfitfun' }],
};

const pages = {
  CAREERS: 'careers',
  JOB_POST: 'job-post',
};

const greenHouse = {
  meta,
  pages,
};

export default greenHouse;
